import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";
import { DoctorAppointment, EAppointmentState } from "src/app/entities/appointment.entity";
import { ConsultationMotif } from "src/app/entities/consultation.entity/consultation-motif.entity/consultation-motif";
import { EDalyTimeSlotLocation } from "src/app/entities/daly-time-slot.entity/daly-time-slot";
import { DoctorAvailability } from "src/app/entities/doctor-disponiblity.entity/doctor-availability";
import { DoctorPatient } from "src/app/entities/doctor-patient.entity/doctor-patient";
import { Doctor } from "src/app/entities/user.entity/doctor.entity";
import { AuthService } from "src/app/services/auth.service/auth.service";
import { DoctorAppointmentService } from "src/app/services/doctor-appointments.service/doctor-appointments.service";
import { DoctorPatientsService } from "src/app/services/doctor-patients.service/doctor-patients.service";
import { DoctorSecretaryAppointmentsService } from "src/app/services/doctor-secretary-appointments.service/doctor-secretary-appointments.service";
import { PublicApisService } from "src/app/services/public-apis.service/public-apis.service";

@Component({
  selector: "app-create-rendez-vous",
  templateUrl: "./create-rendez-vous.component.html",
  styleUrls: ["./create-rendez-vous.component.css"],
})
export class CreateRendezVousComponent implements OnInit, OnChanges {
  @Input() doctorPatients: Array<DoctorPatient> = new Array();
  @Input() userTarget!: DoctorPatient;
  @Input() location: EDalyTimeSlotLocation = EDalyTimeSlotLocation.ATSITE;
  @Input() disponibilites: Array<DoctorAvailability> = new Array();
  @Input() disponibiliteDefalut: number = 0;
  disponibilite: DoctorAvailability | any = new DoctorAvailability({});
  doctorAppointment: DoctorAppointment = new DoctorAppointment({
    status: EAppointmentState.PENDING,
    motif: "Consultation Régulière",
  });
  @Input() consultationMotifs: Array<ConsultationMotif> = [];
  @Input() date: string = "";
  @Input() dateDisponibilte!: Date;
  submited: boolean = false;

  constructor(
    private doctorAppointmentsService: DoctorAppointmentService,
    private authservice: AuthService,
    private toastrService: ToastrService,
    private doctorPatientsService:DoctorPatientsService
  ) {}

  heureInput: string = "";

  @Input() creationPatient: boolean = false;
  @Output() creationPatientChange: EventEmitter<boolean> = new EventEmitter();
  @Output() close: EventEmitter<void> = new EventEmitter();
  @Input() filter: boolean = false;
  @Output() refreshData: EventEmitter<void> = new EventEmitter();

  get doctor(): Doctor {
    return this.authservice.getCurrentUser() as Doctor;
  }

  listesAssistants: Array<any> = new Array();
  selectedAssistant: any;
  selectedColor: string = '';

  changeValueDisponibilte: boolean = false;

  // ✅ COLORS
  colors = [
    { value: "#FADADD", color: "rose clair" },
    { value: "#B8E994", color: "vert pastel" },
    { value: "#FFF9B0", color: "jaune clair" },
    { value: "#A8D8EA", color: "bleu ciel doux" },
    { value: "#FFDAB9", color: "pêche" },
    { value: "#E6E6FA", color: "lavande" },
    { value: "#DFFFBF", color: "vert pomme clair" },
    { value: "#F5F5DC", color: "beige doux" },
    { value: "#BFD7ED", color: "bleu pastel" },
    { value: "#FFB6B9", color: "corail clair" }
  ];

  getRandomColor() {
    return this.colors[Math.floor(Math.random() * this.colors.length)];
  }

  // ✅ FIX: couleur stable par utilisateur (plus de random à chaque sélection)
  applyUserColor(user: any) {
    if (!user) return;

    if (user.colorCodeAct) {
      this.doctorAppointment.colorCode = user.colorCodeAct;
      return;
    }

    if (!user._tempColor) {
      user._tempColor = this.getRandomColor().value;
    }
    this.doctorAppointment.colorCode = user._tempColor;
  }

  isOpen = false;

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  // ✅ sélection manuelle garde priorité
  selectColor(color: string) {
    this.doctorAppointment.colorCode = color;
    this.isOpen = false;
  }

  onTimeChange(event: any) {
    const value = event.target.value;

    if (!value) {
      this.disponibilite.startTime = 0;
      return;
    }

    const [hours, minutes] = value.split(":").map(Number);

    const milliseconds =
      (hours * 60 * 60 * 1000) +
      (minutes * 60 * 1000);

    this.disponibilite.startTime = milliseconds;
    this.disponibiliteDefalut = milliseconds;
  }

  usersList: any[] = [];
  selectedUser: any;

  getAssistants() {
    this.doctorAppointmentsService.getAssistantList().subscribe({
      next: (res: any) => {

        const medecin = {
          ...res.medecin,
          type: 'DOCTOR'
        };

        // ✅ DEFAULT = médecin
        this.selectedUser = medecin;
        this.applyUserColor(medecin);

        const assistants = res.assistants.map((a: any) => ({
          ...a,
          type: 'ASSISTANT'
        }));

        this.usersList = [medecin, ...assistants];

        // ✅ FIX: si un assistantId était déjà défini avant que la liste soit prête
        // (cas où ngOnChanges s'est déclenché avant la fin de cet appel), on le
        // réapplique maintenant que usersList est peuplée.
        if (this.doctorAppointment?.assistantId) {
          const found = this.usersList.find(u => u.id === this.doctorAppointment.assistantId);
          if (found) {
            this.selectedUser = found;
            this.selectedColor = this.doctorAppointment.assistanceColorCode || this.doctorAppointment.colorCode;
          }
        }
      }
    });
  }

  // ✅ utiliser cette méthode dans le HTML
  setSelectedUser(user: any) {
    this.selectedUser = user;
    this.applyUserColor(user);
  }

  onUserChange() {
    if (this.selectedUser) {
      this.selectedColor = this.selectedUser.colorCodeAct || this.selectedUser._tempColor || '#FADADD';
      this.doctorAppointment.colorCode = this.selectedColor;
    }
  }
private patientSearch$: Subject<string> = new Subject<string>();

 ngOnInit(): void {

  this.getAssistants();

  this.location =
    this.doctor.timeSlotLocalSetting == 0
      ? 0
      : this.doctor.timeSlotLocalSetting == 2
        ? 0
        : 1;

  this.changeValueDisponibilte = this.filter !== false;

  if (this.disponibiliteDefalut !== 0) {
    this.heureInput = this.msToTime(this.disponibiliteDefalut);
    this.disponibilite.startTime = this.disponibiliteDefalut;
  }

  this.patientSearch$
    .pipe(
      debounceTime(400),
      distinctUntilChanged(),

      switchMap(search => {
        const value = search.trim();

        return this.doctorPatientsService.searchAll({
          query: value
        });
      })
    )
    
    .subscribe({
      next: (patients: DoctorPatient[]) => {

        console.log('PATIENTS API:', patients);

        this.doctorPatients = patients;

        // IMPORTANT :
        // ton select utilise filteredItems pour afficher
        // les résultats.
      },

      error: (error) => {
        console.error('Erreur recherche patient:', error);
        this.doctorPatients = [];
      }
    });
}
  

  // ✅ FIX: implémente OnChanges + ne réagit qu'aux inputs concernés
  ngOnChanges(changes: SimpleChanges) {
    if (changes['disponibiliteDefalut'] && this.disponibiliteDefalut !== 0) {
      this.heureInput = this.msToTime(this.disponibiliteDefalut);
      this.disponibilite.startTime = this.disponibiliteDefalut;
    }

    if (this.usersList.length && this.doctorAppointment?.assistantId) {
      const found = this.usersList.find(u => u.id === this.doctorAppointment.assistantId);
      if (found) {
        this.selectedUser = found;
        // ✅ init couleur depuis backend
        this.selectedColor = this.doctorAppointment.assistanceColorCode || this.doctorAppointment.colorCode;
      }
    }
  }

  msToTime(ms: number): string {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  refresh(event: DoctorPatient) {
    this.userTarget = event;
    this.refreshData.emit();
  }

  change(event: any) {
    this.changeValueDisponibilte = event.isTrusted;
  }
  onPatientSearch(pattern: string): void {
    this.patientSearch$.next(pattern);
  }
  sumbit() {
    this.submited = true;

    if (!this.userTarget || !this.userTarget.id) {
      this.toastrService.warning("Veuillez sélectionner un patient");
      return; // ✅ FIX: ne ferme plus le modal sur une simple validation manquante
    }

    if (this.changeValueDisponibilte == false && this.disponibiliteDefalut != 0) {
      this.disponibilite.startTime = this.disponibiliteDefalut;

      let disponibiliteExits = this.disponibilites.filter(elm => elm.startTime == this.disponibiliteDefalut);

      if (disponibiliteExits.length > 0)
        this.disponibilite.duration = disponibiliteExits[0].duration;
      else
        this.disponibilite.duration = 30;
    }

    this.doctorAppointment.date = new Date(
      this.dateDisponibilte.getFullYear(),
      this.dateDisponibilte.getMonth(),
      this.dateDisponibilte.getDate()
    );

    this.doctorAppointment.location = this.location;

    // ✅ FIX: garde contre disponibilites vide (évite le crash sur disponibilites[0])
    const fallbackStartTime = this.disponibilites[0]?.startTime ?? 0;
    this.doctorAppointment.startTime =
      this.disponibilite.startTime != 0
        ? this.disponibilite.startTime
        : fallbackStartTime;

    if (!this.doctorAppointment.startTime) {
      this.toastrService.warning("Veuillez sélectionner une heure de rendez-vous");
      return;
    }
console.log('disponibilite.duration', this.disponibilite.duration);

    this.doctorAppointment.duration = this.disponibilite.duration;

    this.doctorAppointment.assistantId = this.selectedUser?.id || null;

    this.doctorAppointmentsService
      .add(this.userTarget.id, this.doctorAppointment)
      .subscribe({
        next: (res: any) => {
          this.toastrService.success("Rdv créé avec succès");

          this.doctorAppointment = new DoctorAppointment({});
          this.changeValueDisponibilte = false;
          this.userTarget = new DoctorPatient();

          this.refreshData.emit();
          this.close.emit();
        },

        error: (err) => {
          const msg = err?.error?.message || "Erreur lors de la création du rendez-vous";
          this.toastrService.error(msg);
          this.close.emit();
        }
      });
  }
}